import { RequestSourceEnum } from '@talos/kyoko';

/** Create-only RequestSource: explicit wins, else UIMobile on mobile layout; undefined → backend default UI. */
export function resolveUiRequestSource({
  isMobileLayout,
  explicit,
}: {
  isMobileLayout: boolean;
  explicit?: RequestSourceEnum;
}): RequestSourceEnum | undefined {
  if (explicit) {
    return explicit;
  }
  if (isMobileLayout) {
    return RequestSourceEnum.UIMobile;
  }
  return undefined;
}
